import SubTasksService from '../../../modules/subTasks/subTasksService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'SUBTASKS_FORM'

const subTasksFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subTasksFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await SubTasksService.find(id)
      }

      dispatch({
        type: subTasksFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subTasksFormActions.INIT_ERROR,
      })

      dispatch(push('/sub-tasks'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: subTasksFormActions.CREATE_STARTED,
      })

      await SubTasksService.create(values)

      dispatch({
        type: subTasksFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.subTasks.create.success'),
      )

      dispatch(push('/sub-tasks'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subTasksFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: subTasksFormActions.UPDATE_STARTED,
      })

      await SubTasksService.update(id, values)

      dispatch({
        type: subTasksFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.subTasks.update.success'),
      )

      dispatch(push('/sub-tasks'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subTasksFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default subTasksFormActions
